import {
  addDoc,
  collection,
  getDocs,
  getFirestore,
  query,
  serverTimestamp,
  where,
  doc,
  setDoc,
} from "firebase/firestore";
import firebaseApp from "../../firebase/credenciales";
import { CONT_COLLECTIONS } from "./collections";

const db = getFirestore(firebaseApp);

const txt = (v) => (v == null ? "" : String(v).trim());
const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? Number(n.toFixed(2)) : 0;
};

const toUpper = (v) => txt(v).toUpperCase();

const buildCodigo = ({ tipoDocumento, serie, numero }) => {
  const tipo = toUpper(tipoDocumento);
  const s = txt(serie);
  const n = txt(numero);
  return [tipo, s, n].filter(Boolean).join("-");
};

export const registrarDocumentoComercial = async ({
  rucEmpresa,
  tipoDocumento,
  serie,
  numero,
  fecha,
  monto,
  moneda,
  moduloOrigen,
  entidadId,
  entidadTipo,
  relacionadoCon = [],
  metadata = {},
}, transaction) => {
  const ruc = txt(rucEmpresa);
  if (!ruc) throw new Error("RUC empresa inválido para registrar documento.");

  const tipo = toUpper(tipoDocumento);
  if (!tipo) throw new Error("Tipo de documento inválido.");

  const payload = {
    ruc_empresa: ruc,
    tipo_documento: tipo,
    serie: txt(serie),
    numero: txt(numero),
    codigo_documento: buildCodigo({ tipoDocumento: tipo, serie, numero }),
    fecha: txt(fecha),
    monto: num(monto),
    moneda: txt(moneda || "PEN"),
    modulo_origen: txt(moduloOrigen),
    entidad_id: txt(entidadId),
    entidad_tipo: txt(entidadTipo),
    relacionado_con: Array.isArray(relacionadoCon) ? relacionadoCon : [],
    metadata: metadata && typeof metadata === "object" ? metadata : {},
    estado: "REGISTRADO",
    created_at: serverTimestamp(),
    updated_at: serverTimestamp(),
  };

  const ref = doc(collection(db, CONT_COLLECTIONS.DOCUMENTOS_COMERCIALES));
  if (transaction) {
    transaction.set(ref, payload);
  } else {
    await setDoc(ref, payload);
  }
  return ref.id;
};

export const obtenerDocumentosComercialesPorEmpresa = async (rucEmpresa, tipos = []) => {
  const ruc = txt(rucEmpresa);
  if (!ruc) return [];

  const q = query(collection(db, CONT_COLLECTIONS.DOCUMENTOS_COMERCIALES), where("ruc_empresa", "==", ruc));
  const snap = await getDocs(q);
  let rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));

  if (Array.isArray(tipos) && tipos.length > 0) {
    const setTipos = new Set(tipos.map((x) => toUpper(x)));
    rows = rows.filter((x) => setTipos.has(toUpper(x.tipo_documento)));
  }

  return rows.sort((a, b) => String(b.fecha || "").localeCompare(String(a.fecha || "")));
};
